export default "__VITE_ASSET__bdca5731__"